import React from 'react';
import theme from '~/theme';
import { css } from '@emotion/react';
import PropTypes from 'prop-types';

import GravityForm from '~/components/GravityForm';
import { srOnly } from '~/styles/helpers';

import { formElement, input } from '~/styles/forms';

const EmphasisGravityForm = ({ size = 'normal', reverse = false, formId }) => {
    const customCss = css`
        .gravityform {
            ${formElement({ theme })};
        }

        .gform_fields {
            gap: 0;
        }

        .gform_body {
            flex: 1 1 auto;
        }

        .gform_heading {
            display: none;
        }

        .gravityform__label {
            ${srOnly};
        }

        .gform_footer {
            padding: 0;
            margin: 0;
        }

        .gravityform__field__input {
            ${input({ theme, size, reverse, emphasis: true })};
        }

        .gravityform__button {
            padding-top: 0;
            padding-bottom: 0;
            height: 100%;
        }

        button[type='submit'] {
            &:focus-visible {
                outline: none;
            }
        }

        .gravityform__error_message,
        .gravityform__error_inform {
            position: absolute;
            top: calc(100% + 12px);
            left: 0;
        }

        .gform_confirmation_message {
            font-size: 1.7rem;
            ${reverse && `color: ${theme.colors.primary.white}`};
            font-weight: ${theme.fontWeights.medium};
        }
    `;

    return <GravityForm {...{ formId, customCss }} />;
};

EmphasisGravityForm.propTypes = {
    size: PropTypes.oneOf(['normal', 'large']),
    reverse: PropTypes.bool,
    formId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired
};

export default EmphasisGravityForm;
